<nav class="header__menu">
  <ul class="header__menu-list">
    <ng-container *ngFor="let option of options">
      <li class="col-12 py-0 px-0 pr-0 header__menu-item"
        *ngIf="option.url || (option.children && option.children.length > 0)">
        <ms-khuyana-header-submenu [menuOption]="option" class="header__menu-content"
          (selected)="option.isSelected = $event" (leave)="onLinkClick()">
        </ms-khuyana-header-submenu>
      </li>
    </ng-container>

    <li class="col-12 py-0 px-0 header__menu-item header__menu-item--logout" [routerLink]="[ '/salir' ]"
      (click)="onLinkClick()">
      <h3 class="header__menu-content" [style.width.%]="100">
        <a class="header__menu-content-text px-3" [routerLink]="[ '/salir' ]" (click)="onLinkClick()">
          <i class="header__menu-content-icon fas fa-door-open"></i>Salir
        </a>
      </h3>
    </li>
  </ul>
</nav>